import { OrgData } from "@p0security/shared/types/tenant/index";
import { PropsWithChildren } from "react";

import { useFirebaseAuth } from "../hooks/useFirebaseAuth";
import { Tenant } from "../types/auth";
import { UserAuthContext } from "./UserAuthProvider";

type Props = {
  tenant: Tenant;
  orgData: OrgData | undefined;
  orgSlug: string | undefined;
};

export const FirebaseUserProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  tenant,
  orgData,
  orgSlug,
}) => {
  const auth = useFirebaseAuth(tenant, orgData, orgSlug);

  return (
    <UserAuthContext.Provider value={auth}>{children}</UserAuthContext.Provider>
  );
};
